// Planner action type constants

// Calendar selection
export const SET_SELECTED_CALENDAR = 'SET_SELECTED_CALENDAR';

// Mode toggle
export const SET_PLANNER_MODE = 'SET_PLANNER_MODE';

// Loaded week range (for infinite scrolling)
export const SET_LOADED_WEEK_RANGE = 'SET_LOADED_WEEK_RANGE';
export const LOAD_MORE_WEEKS_START = 'LOAD_MORE_WEEKS_START';
export const LOAD_MORE_WEEKS_FULFILLED = 'LOAD_MORE_WEEKS_FULFILLED';
export const LOAD_MORE_WEEKS_REJECTED = 'LOAD_MORE_WEEKS_REJECTED';

// Plan operations
export const CREATE_PLAN_FULFILLED = 'CREATE_PLAN_FULFILLED';

// Block CRUD operations
export const CREATE_BLOCK_FULFILLED = 'CREATE_BLOCK_FULFILLED';
export const UPDATE_BLOCK_FULFILLED = 'UPDATE_BLOCK_FULFILLED';
export const DELETE_BLOCK_FULFILLED = 'DELETE_BLOCK_FULFILLED';

// Bulk copy and delete blocks
export const BULK_COPY_BLOCKS_START = 'BULK_COPY_BLOCKS_START';
export const BULK_COPY_BLOCKS_FULFILLED = 'BULK_COPY_BLOCKS_FULFILLED';
export const BULK_COPY_BLOCKS_REJECTED = 'BULK_COPY_BLOCKS_REJECTED';
export const BULK_DELETE_BLOCKS_START = 'BULK_DELETE_BLOCKS_START';
export const BULK_DELETE_BLOCKS_FULFILLED = 'BULK_DELETE_BLOCKS_FULFILLED';
export const BULK_DELETE_BLOCKS_REJECTED = 'BULK_DELETE_BLOCKS_REJECTED';

export const FETCH_PLANNER_START = 'FETCH_PLANNER_START';
export const FETCH_PLANNER_FULFILLED = 'FETCH_PLANNER_FULFILLED';
export const FETCH_PLANNER_REJECTED = 'FETCH_PLANNER_REJECTED';

// Batched action: Load weeks and blocks together
export const LOAD_MORE_WEEKS_AND_BLOCKS_FULFILLED = 'LOAD_MORE_WEEKS_AND_BLOCKS_FULFILLED';

// Batched action: Update multiple blocks at once
export const UPDATE_MULTIPLE_BLOCKS_FULFILLED = 'UPDATE_MULTIPLE_BLOCKS_FULFILLED';

// Notes operations
export const UPSERT_NOTE_FULFILLED = 'UPSERT_NOTE_FULFILLED';
export const DELETE_NOTE_FULFILLED = 'DELETE_NOTE_FULFILLED';

// UI state
export const SET_PLANNER_EXAMPLES_MODAL_OPEN = 'SET_PLANNER_EXAMPLES_MODAL_OPEN';
export const SET_SELECTED_CALENDAR_NAME = 'SET_SELECTED_CALENDAR_NAME';
